export default {
	singapore: 'สิงคโปร์',
	thailand: 'ประเทศไทย',
	malaysia: 'มาเลเซีย',
	education_calculator: 'เครื่องคิดเลขการศึกษา',
	see_how_much: 'ดูว่าการศึกษาของเด็กมีค่าใช้จ่ายเท่าไรใน {entity} และต่างประเทศ และวิธีหาทุน',
	financing_for_education:
		'การจัดหาเงินทุนเพื่อการศึกษาอาจเป็นเรื่องยากและจะต้องมีการวางแผนอย่างรอบคอบ มาดูกันว่าเราจะทำอะไรได้บ้างเพื่อให้จัดการได้ง่ายขึ้นสำหรับคุณ',
	next: 'ต่อไป',
	back: 'กลับ',
	your_childs_profile: 'โปรไฟล์ลูกของเรา',
	let_me_help: 'ให้ฉันช่วยคุณ',
	estimations_only:
		'*ประมาณการเท่านั้น โปรดดูข้อมูลเพิ่มเติมจากที่ปรึกษาทางการเงินที่เชื่อถือได้ของคุณ',
	grow_your_education_savings:
		'เพิ่มเงินออมเพื่อการศึกษาของคุณให้มากขึ้นด้วยการเลือกผลิตภัณฑ์ทางการเงินที่เหมาะสม',
	each_year: '% แต่ละปี',
	assuming_your_money: 'สมมติว่าเงินของคุณจะเติบโตโดย',
	year: 'ปี*',
	base_your_goal: 'จากเป้าหมายที่เลือก คุณจำเป็นต้องเตรียมเงินทั้งหมด ',
	education_cost_brief:
		'รวมค่าเล่าเรียนและค่าครองชีพ (หาตัวเลขเหล่านี้ได้จากที่ใด โปรดดูที่ว่าง <i> <a href="https://support.goalsmapper.com/hc/en-us/articles/900004799406-How-is-the-data-for-the-Education-Planner-widget-collected-" rel="noopener noreferrer" target="_blank"> อ้างอิง</a></i>.)',
	where_to_study: 'คุณต้องการให้พวกเขาเรียนที่ไหน',
	education_study_destination: 'ปลายทางการศึกษา',
	field_of_study: 'สาขาวิชา',
	year_of_study: 'ปีการศึกษา',
	year_singular: 'ปี',
	years_to_enrolment: 'ปีที่ลงทะเบียน',
	age: 'อายุ',
	foreigner: 'ชาวต่างชาติ',
	citizen_pr: 'พลเมือง/ถิ่นที่อยู่ถาวร',
	what_residency_status: 'สถานะการพำนักของคุณคืออะไร?',
	child_field_of_study: 'สาขาวิชาของบุตรหลานของท่าน',
	university_age: 'อายุเข้ามหาวิทยาลัย',
	childs_age: 'อายุของเด็ก',
	start_telling: 'เริ่มต้นด้วยการบอกโปรไฟล์ของบุตรหลานของคุณ',
	set_aside: 'คุณจำเป็นต้องเก็บเงินตั้งแต่วันนี้ ปีละ ',
	profile: 'ประวัติโดยย่อ',
	plan: 'วางแผน',
	total_cost_includes: 'รวมค่าใช้จ่าย',
	ok: 'ตกลง',
	annual_cost_from: 'ค่าใช้จ่ายรายปีจาก ',
	today: 'วันนี้',
	select: 'เลือก',
	death: 'ความตาย',
	critical_illness: 'โรคร้ายแรง',
	disability_tpd: 'ความพิการ (TPD)',
	insurance_coverage_brief: 'แจ้งความคุ้มครองประกันปัจจุบันของคุณ',
	profile_brief: 'เริ่มต้นด้วยการบอกโปรไฟล์ของคุณให้เราทราบ',
	these_information: 'ข้อมูลเหล่านี้ช่วยให้เราเข้าใจถึงพื้นฐานของความต้องการประกันภัยของคุณ',
	your_age: 'อายุของคุณ',
	your_gender: 'เพศของคุณ',
	your_life_expectancy: 'อายุขัยของคุณ',
	insurance_estimation:
		'*ประมาณการตามข้อมูลจาก <a target="_blank" rel="noopener noreferrer" href="https://www.worldometers.info/demographics/life-expectancy/">Worldometers.info</a>',
	your_monthly_expense: 'ค่าใช้จ่ายรายเดือนของคุณ',
	mandatory_field: '" (เขตบังคับ)"',
	see_below: 'ดูข้อมูลสรุปความคุ้มครองของคุณด้านล่าง*',
	increase_your_coverage: 'ดูต่อไปว่าคุณจะเพิ่มความครอบคลุมได้อย่างไร',
	estimation_only:
		'*ประมาณการเท่านั้น โปรดดูข้อมูลเพิ่มเติมจากที่ปรึกษาทางการเงินที่เชื่อถือได้ของคุณ',
	exisiting_coverage: 'ความคุ้มครองที่มีอยู่',
	coverage_needed: 'ความคุ้มครองที่จำเป็น',
	coverage_gap: 'ช่องว่างความครอบคลุม (ขาดแคลน)',
	years: 'ปี',
	what_if: 'เกิดอะไรขึ้นถ้า...',
	what_if_one: 'เกิดอะไรขึ้นถ้า...1',
	what_if_two: 'เกิดอะไรขึ้นถ้า...2',
	questions_below:
		'คำถามบางข้อด้านล่างนี้ "จะเกิดอะไรขึ้นถ้า" หากคุณมีปัญหาในการตอบคำถาม ให้ลองประมาณการหรือสมมติฐานคร่าวๆ',
	ci_event: 'กรณีเจ็บป่วยร้ายแรง คุณอยากได้รับการเลี้ยงดูเป็นเวลากี่ปี?',
	disability_event: 'กรณีทุพพลภาพ ท่านต้องการให้มีอายุกี่ปี ?',
	passing_on: 'กรณีส่งต่อ…',
	provide_your_family: 'คุณต้องการให้ครอบครัวของคุณมากแค่ไหน?',
	month: 'เดือน',
	your_insurance: 'ประกันภัยของคุณ',
	planning_your_protection:
		'การวางแผนความต้องการด้านการป้องกันของคุณอาจเป็นเรื่องยากและจะต้องมีการวางแผนอย่างรอบคอบ มาดูกันว่าเราจะทำอะไรได้บ้างเพื่อให้จัดการได้ง่ายขึ้นสำหรับคุณ',
	find_out_insurance: 'ค้นหาว่าความคุ้มครองที่มีอยู่ของคุณเพียงพอสำหรับคุณหรือไม่',
	based_on_your: 'จากข้อมูลที่คุณป้อน คุณ ',
	you_should_retire_by: 'จากข้อมูลที่คุณป้อน คุณควรจะสามารถเกษียณอายุได้เมื่ออายุของ ',
	your_monthly_income: 'รายได้ต่อเดือนของคุณ',
	your_profile: 'โปรไฟล์ของคุณ',
	expect_to_live: 'คาดว่าจะมีชีวิตอยู่จนถึง',
	monthly_income: 'รายได้ต่อเดือน',
	monthly_expense: 'ค่าใช้จ่ายรายเดือน',
	percent_each_year: '% แต่ละปี.',
	adjust_growth_rate:
		'ปรับอัตราการเติบโตของเงินออมของคุณ เพื่อดูว่ามันสร้างความแตกต่างให้กับอายุเกษียณของคุณอย่างไร',
	let_me_show: 'ให้ฉันแสดงวิธีทำให้อายุเกษียณที่คุณต้องการเป็นจริง',
	retirement_planner: 'ผู้วางแผนการเกษียณอายุ',
	find_out_how_old: 'ค้นหาอายุที่คุณสามารถเกษียณจากการออมและรูปแบบการใช้จ่ายของคุณในวันนี้',
	gender_required: 'เพศเป็นฟิลด์บังคับ',
	age_required: 'อายุเป็นฟิลด์บังคับ',
	life_required: 'อายุเป็นฟิลด์บังคับ',
	life_expectancy: 'อายุขัยต้องอยู่หลังอายุปัจจุบัน',
	expense_required: 'ค่าใช้จ่ายรายเดือนเป็นฟิลด์บังคับ',
	required_field: 'ช่องที่ต้องกรอก',
	field: 'สนาม',
	positive_number: 'ต้องเป็นจำนวนบวก',
	million: 'ล้าน',
	shortfall: 'ขาดแคลน',
	coverage: 'ความคุ้มครอง',
	please_check: 'โปรดทำเครื่องหมายที่ช่องนี้เพื่อดำเนินการต่อ',
	checked: 'ตรวจสอบแล้ว',
	cannot_exceed: 'ข้อความต้องมีอักขระไม่เกิน 500 ตัว',
	phone_required: 'หมายเลขโทรศัพท์เป็นฟิลด์บังคับ',
	name_required: 'ชื่อเป็นฟิลด์บังคับ',
	get_in_touch: 'ได้รับการติดต่อ',
	your_name: 'ชื่อของคุณ',
	your_mobile: 'มือถือของคุณ',
	message: 'ข้อความ',
	success: 'ความสำเร็จ!',
	in_touch_soon:
		'ฉันจะติดต่อคุณในไม่ช้า คุณสามารถปิดหน้านี้และกลับมายังเว็บไซต์ของฉันเพื่อดูข้อมูลเพิ่มเติมได้',
	contact_disclaimer: `<div>ฉันยินยอมให้มีการรวบรวม ใช้ และเปิดเผยข้อมูลส่วนบุคคลของฉันโดย
							{AGENT_NAME} เพื่อวัตถุประสงค์ดังต่อไปนี้
							<br />
							a. ปฏิบัติตามภาระผูกพันในระหว่างหรือที่เกี่ยวข้องกับ .ของเรา
							การจัดหาสินค้าและ/หรือบริการที่คุณร้องขอ;
							<br />
							b. ส่งข้อมูลการตลาดเกี่ยวกับสินค้าหรือบริการของเราให้คุณ
							รวมถึงการแจ้งให้คุณทราบถึงกิจกรรมทางการตลาด ความคิดริเริ่ม และ
							โปรโมชั่น การจับฉลาก สมาชิกและรางวัล และอื่นๆ
							โปรโมชั่น;
							<br />
							c. ปฏิบัติตามกฎหมาย ข้อบังคับ ประมวลกฎหมายของ
							แนวปฏิบัติ แนวทาง หรือกฎเกณฑ์ หรือเพื่อช่วยเหลือในการบังคับใช้กฎหมายและ
							การสอบสวนที่ดำเนินการโดยรัฐบาลและ/หรือหน่วยงานกำกับดูแลใดๆ
							อำนาจ;
							<br />
							d. วัตถุประสงค์อื่นใดที่คุณได้ให้ข้อมูลไว้;
							<br />
							โปรดดำเนินการต่อหากคุณตกลงที่จะติดต่อเพื่อวัตถุประสงค์ข้างต้น</div>`,
	income_required: 'รายได้ต่อเดือนเป็นช่องที่ต้องกรอก',
	unable_retire: 'ไม่สามารถเกษียณอายุได้',
	study_required: 'สาขาวิชาเป็นสาขาวิชาบังคับ',
	university_age_required: 'อายุที่เข้ามหาวิทยาลัยเป็นสาขาที่กำหนด',
	study_country: 'ประเทศที่เรียน',
	living_expenses: 'ค่าครองชีพ',
	food: 'อาหาร',
	transport: 'ขนส่ง',
	books: 'หนังสือ',
	accommodation: 'ที่พัก',
	personal_expenses: 'ค่าใช้จ่ายส่วนตัว',
	all_citizenship: 'สัญชาติทั้งหมด',
	pr: 'ถิ่นที่อยู่ถาวร',
	international: 'ระหว่างประเทศ',
	singaporean: 'สิงคโปร์เท่านั้น',
	tuition_fee: 'ค่าเล่าเรียน',
	total_per_year: 'รวม (ต่อปี)',
	accountancy: 'การบัญชี',
	architecture: 'สถาปัตยกรรม',
	arts: 'ศิลปะ',
	arts_science: 'ศิลปะ/วิทยาศาสตร์',
	business: 'ธุรกิจ',
	computing: 'คอมพิวเตอร์',
	engineering: 'วิศวกรรม',
	law: 'กฎ',
	medicine: 'ยา',
	music: 'ดนตรี',
	science: 'ศาสตร์',
	aus: 'ออสเตรเลีย',
	ca: 'แคนาดา',
	cn: 'จีน',
	jp: 'ญี่ปุ่น',
	my: 'มาเลเซีย',
	uk: 'ประเทศอังกฤษ',
	us: 'สหรัฐ',
	sg: 'สิงคโปร์',
	th: 'ประเทศไทย',
	id: 'อินโดนีเซีย',
	THB: 'บาท',
	for_how_long: 'เป็นเวลากี่ปี',
	private: 'ส่วนตัว',
	mortgage_planner: 'เครื่องมือวางแผนสินเชื่อที่อยู่อาศัย',
	mortgage_planner_subtitle:
		'เข้าถึงอัตราดอกเบี้ยและแพ็กเกจสินเชื่อบ้านที่แข่งขันได้จากสถาบันการเงินชั้นนำ ง่าย รวดเร็ว สะดวก',
	medical_concierge: 'บริการผู้ช่วยด้านการแพทย์',
	medical_concierge_subtitle:
		'บริการดูแลสุขภาพแบบส่วนตัวเพียงปลายนิ้ว และเข้าถึงเครือข่ายแพทย์เฉพาะทางชั้นนำ',
	gm_medical_concierge_title1: 'เชื่อมต่อบริการดูแลสุขภาพแบบส่วนตัว',
	gm_medical_concierge_description1:
		'GM Medical Concierge เชื่อมต่อคุณกับบริการดูแลสุขภาพแบบส่วนตัวอย่างไร้รอยต่อผ่านความร่วมมือเชิงกลยุทธ์กับผู้ให้บริการ Medical Concierge ชั้นนำ',
	gm_medical_concierge_title2: 'เข้าถึงเครือข่ายแพทย์เฉพาะทางชั้นนำ',
	gm_medical_concierge_description2:
		'GM Medical Concierge ช่วยให้เข้าถึงเครือข่ายแพทย์ผู้เชี่ยวชาญชั้นนำได้อย่างง่ายดาย โดยไม่ต้องเสียเวลาค้นหา <br/><br/>คุณสามารถติดต่อผู้เชี่ยวชาญที่เหมาะกับความต้องการเฉพาะของคุณ โดยให้ความสำคัญกับความสะดวกและการดูแลที่เหมาะสมที่สุด',
	gm_medical_concierge_title3: 'เข้าถึงการรักษาได้ทันท่วงที',
	gm_medical_concierge_description3:
		'GM Medical Concierge ช่วยให้เข้าถึงบริการทางการแพทย์ได้อย่างรวดเร็วผ่านการนัดหมายที่คล่องตัวและการจัดการรักษาเฉพาะทางอย่างมีประสิทธิภาพ ความร่วมมือกับผู้ให้บริการด้านสุขภาพช่วยลดเวลารอ ทำให้คุณจัดการความต้องการได้ทันเวลา',
	gm_medical_concierge_let_me_show: 'ให้ฉันช่วยคุณเรื่องนี้',
	latest_mortgage_rates: 'อัตราสินเชื่อที่อยู่อาศัยล่าสุด',
	loan_affordability: 'ความสามารถในการผ่อนสินเชื่อ',
	our_bank_partners: 'พันธมิตรธนาคารของเรา',
	rate_fix: 'คงที่',
	rate_var: 'ลอยตัว',
	rate_vbu: 'ลอยตัว (UC)',
	mortgage_lockin_period: 'ระยะเวลาล็อกอิน',
	mortgage_partial_prepayment: 'การชำระคืนก่อนกำหนดบางส่วน',
	mortgage_free_conversion: 'เปลี่ยนแพ็กเกจฟรี',
	mortgage_penalty_waiver: 'ยกเว้นค่าปรับ (กรณีขายทรัพย์สิน)',
	mortgage_rebate_subsidy: 'เงินคืน/เงินอุดหนุนค่ากฎหมาย',
	year1_interest: 'ดอกเบี้ยปีที่ 1',
	year2_interest: 'ดอกเบี้ยปีที่ 2',
	year3_interest: 'ดอกเบี้ยปีที่ 3',
	year4_interest: 'ดอกเบี้ยปีที่ 4',
	year5_interest: 'ดอกเบี้ยปีที่ 5',
	thereafter_interest: 'ดอกเบี้ยหลังจากนั้น ',
	min_loan_amount: 'วงเงินสินเชื่อขั้นต่ำ',
	interest_rate_display: '<strong>[{realRate}]</strong> {rateString}',
	mortgage_packages_last_updated: 'ข้อมูลอัปเดตล่าสุดเมื่อ {lastUpdated}',
	available_amount: 'วงเงินที่ใช้ได้',
	tdsr_description:
		'TDSR คำนวณโดยนำยอดชำระหนี้รายเดือนหารด้วยรายได้รวมต่อเดือน การคำนวณนี้อ้างอิงจากข้อมูลที่ลูกค้าให้มา',
	total_tdsr: 'TDSR รวม',
	available_tdsr: 'TDSR ที่ใช้ได้',
	current_tdsr: 'TDSR ปัจจุบัน',
	affordability_details: 'รายละเอียดความสามารถในการผ่อน',
	private_ec_affordability: 'อสังหาฯ เอกชนและ EC',
	private_bank_affordability: 'สินเชื่อต่ำกว่า 55% ของราคาซื้อ',
	hdb_affordability: 'อสังหาฯ HDB',
	income_weighted_average_age: 'อายุเฉลี่ยถ่วงน้ำหนักตามรายได้',
	recognised_income: 'รายได้ต่อเดือนที่รับรอง',
	current_debt: 'ภาระหนี้รายเดือนปัจจุบัน',
	max_loan_tenure_hdb: 'ระยะเวลาสินเชื่อสูงสุด (HDB)',
	max_loan_tenure_private_ec: 'ระยะเวลาสินเชื่อสูงสุด (เอกชน/EC)',
	max_loan_tenure_below_55: 'ระยะเวลาสินเชื่อสูงสุด (< 55% ของราคาซื้อ)',
	median_interest: 'อัตราดอกเบี้ยมัธยฐาน',
	monthly_mortgage_limit: 'วงเงินผ่อนบ้านรายเดือนสำหรับ {ownership}',
	joint_liability_disclaimer:
		'การชำระเงินสดสำหรับความรับผิดร่วมจะแบ่งเท่าๆ กันระหว่างลูกค้าและคู่สมรส',
	contact_mortgage_specialist: 'ติดต่อผู้เชี่ยวชาญสินเชื่อที่อยู่อาศัย GM',
	variable_income_description: 'รวมรายได้จากค่าเช่า โบนัส และคอมมิชชั่น',
	tdsr_total_income_description:
		'รายได้รวมคำนวณจาก 100% ของรายได้รวมต่อเดือน + 70% ของรายได้ผันแปรต่อเดือน',
	tdsr_limit_description:
		'รายได้รวมสูงสุดที่สามารถใช้ชำระหนี้ได้ (จำกัดสูงสุดที่ 55%)',
	available_tdsr_description:
		'รายได้รวมที่เหลือสำหรับการก่อหนี้ใหม่ หลังจากคำนึงถึงหนี้ปัจจุบันที่คุณกำลังผ่อนอยู่',
	current_tdsr_description: 'รายได้รวมที่กำลังใช้ในการชำระหนี้ในปัจจุบัน',
	additional_info: 'ข้อมูลเพิ่มเติม',
	RESIDE: 'สินเชื่อที่อยู่อาศัย',
	CARLOA: 'สินเชื่อรถยนต์',
	RENOVA: 'สินเชื่อตกแต่งบ้าน',
	STUDYL: 'สินเชื่อเพื่อการศึกษา',
	CREDIT: 'สินเชื่อบัตรเครดิต',
	PERSON: 'สินเชื่อส่วนบุคคล',
	OTHERS: 'สินเชื่ออื่นๆ',
	INTONL: 'สินเชื่อจ่ายดอกเบี้ยเท่านั้น',
	total_monthly_liability: 'ภาระหนี้รายเดือนรวม',
	total_monthly_income: 'รายได้ต่อเดือนรวม',
	income: 'รายได้',
	liability: 'หนี้สิน',
	check_out_latest_rates:
		'ปลดล็อกอัตราสินเชื่อบ้านในอุดมคติของคุณ: สำรวจตัวเลือกอัตราคงที่หรือลอยตัวจากธนาคารชั้นนำได้เลย!',
	calculate_affordability:
		'วางแผนบ้านในฝันอย่างชาญฉลาด! คำนวณความสามารถในการผ่อนสินเชื่อวันนี้ เพื่อการหาบ้านอย่างสบายใจในวันพรุ่งนี้',
	applicant_details: 'รายละเอียดผู้สมัคร',
	main_applicant: 'ผู้สมัครหลัก',
	joint_applicant: 'ผู้สมัครร่วม',
	recommended: 'แนะนำ'

};
